<template>
  <div
    class="univ-name ml-3  sm:ml-4 md:ml-4 lg:ml-5 flex flex-col text-left justify-center"
  >
    <h1
      class="text-white text-4xl sm:text-5xl md:text-6xl lg:text-[70px] font-medium leading-tight"
    >
      STIKES
    </h1>
    <h1
      class="text-white text-lg sm:text-2xl md:text-3xl lg:text-4xl mt-[-7px] md:mt-0 font-medium leading-tight"
    >
      SUMBER WARAS
    </h1> 
  </div>  
</template>
